import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, Signal } from '@angular/core';
import { IResearchOverviewItem } from '~global-interfaces/IResearchOverviewItem';

import { ResearchListComponent } from '~features/research/research-list/research-list.component';

@Component({
  selector: 'app-research-list-dialog',
  imports: [ResearchListComponent],
  templateUrl: './research-list-dialog.component.html',
})
export class ResearchListDialogComponent {
  constructor(
    public dialogRef: DialogRef<string>,
    @Inject(DIALOG_DATA) public data: Signal<IResearchOverviewItem[] | null>
  ) {}
}
